// DashboardCard.js
import React from "react";
import { motion } from "framer-motion";

const DashboardCard = ({ title, icon, count, description }) => {
  return (
    <motion.div whileHover={{ y: -3 }} className="mb-4 h-100">
      <div className="card shadow-sm h-100 border-0">
        <div className="card-body d-flex align-items-center gap-3">
          <div className="dashboard-icon-badge">{icon}</div>
          <div>
            <p className="text-uppercase text-muted small fw-semibold mb-1">
              {title}
            </p>
            <h3 className="fw-bold mb-0">{count}</h3>
            <p className="text-muted small mb-0">{description}</p>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default DashboardCard;
